<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead :current-tab="currentTab" />

    <div class="section fill">
      <div class="inner delivery_detail order">
        <div class="box_title">
          <h2>{{ $t('views.member.orderdetail.5403') }}</h2>
          <!-- <p class="guide_txt">{{ $t('views.member.orderdetail.637') }}</p>-->
        </div>

        <div v-if="order" class="mypage_detail book_num">
          <div class="box">
            <div class="order_title">
              <dl>
                <dt>{{ $t('views.member.orderdetail.6084') }}</dt>
                <dd>
                  <span>{{ order.orderDtime | timestamp }}</span>
                </dd>
              </dl>
              <dl>
                <dt>{{ $t('views.member.orderdetail.822') }}</dt>
                <dd>
                  <span class="num">{{ order.orderCd }}</span>
                </dd>
              </dl>
            </div>
            <ul class="order_book">
              <!-- TODO: This should be a component which is also used on the /account page ('orders' view) -->
              <li v-for="(item, idx) in order.orderGoodsList" :key="idx">
                <div class="cover_wrap">
                  <router-link
                    :to="{
                      name:
                        item.bookTp === 'EBOOK'
                          ? 'library_book_detail'
                          : 'book_detail',
                      params: { id: item.bookCd }
                    }"
                    class="thum_wrap"
                  >
                    <img :src="item.thumbUrl" :alt="item.bookNm" />
                  </router-link>
                </div>
                <div class="info_wrap">
                  <h3 class="meta_title">{{ item.bookNm }}</h3>
                  <p>
                    <span class="meta_author">{{ item.author }}</span>

                    <span class="meta_publisher">{{ item.publisher }}</span>
                  </p>
                  <p>
                    <span class="meta_type">{{ item.bookTp }}</span>
                  </p>
                  <p>
                    <span class="meta_num"
                      >{{ $t('views.member.orderdetail.total') }}
                      <span class="num">{{ item.units }}</span
                      >{{ $t('views.member.orderdetail.books') }}
                    </span>
                    <span v-if="item.saleAmt">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.saleAmt"
                      />
                    </span>

                    <span v-if="!item.saleAmt">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="0"
                      />
                    </span>
                  </p>
                </div>
                <div v-show="item.menuShowYn === 'Y'" class="btn_wrap">
                  <div class="cell">
                    <p class="state_txt" :class="{ c_black: item.deliveryMsg }">
                      {{
                        item.ebookOrders && item.ebookOrders.ebookOptNm
                          ? item.ebookOrders.ebookOptNm
                          : item.purchaseTp === 'PRS'
                          ? '증정본'
                          : '선물'
                      }}
                    </p>
                    <router-link
                      v-if="!item.buyTp.ebook"
                      :to="{
                        name: 'order_tracking',
                        params: { id: order.orderCd, order }
                      }"
                      class="box_btn dull"
                      :class="{ none: order.delivery.trackingYn === 'N' }"
                      ><span class="an_t">{{
                        $t('views.member.orderdetail.5638')
                      }}</span></router-link
                    >
                  </div>

                  <div class="cell">
                    <!-- If order item is not in return requested status -->
                    <template v-if="item.deliveryMsg !== '반품 요청 중'">
                      <a
                        v-if="!item.buyTp.ebook"
                        class="box_btn max cancel_button"
                        :class="{ none: item.cancelYn === 'N' }"
                        @click="toggleCancelOrderModal"
                        ><span class="an_t">{{
                          $t('views.member.orderdetail.4762')
                        }}</span></a
                      >
                      <router-link
                        v-if="!item.buyTp.ebook && currentTab !== 'returns'"
                        :to="{
                          name: 'request_return',
                          params: { id: order.orderCd, item, order }
                        }"
                        :class="{
                          none: item.returnYn === 'N'
                        }"
                        class="box_btn line return_button"
                        ><span class="an_t">{{
                          item.returnYnMsg
                        }}</span></router-link
                      >
                    </template>
                    <!-- If order item is in return requested status -->
                    <template v-else>
                      <button
                        type="submit"
                        class="box_btn line"
                        @click="toggleCancelReturnModal"
                      >
                        <span class="an_t">{{
                          $t('views.member.orderdetail.6449')
                        }}</span>
                      </button>
                    </template>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="order.purchaseTp === 'GFT'" class="box delivery_info">
            <div class="top_title">
              <p>선물 정보</p>
            </div>

            <div class="receiver_wrap fl">
              <dl>
                <dt>{{ $t('views.member.orderdetail.4683') }}</dt>
                <dd>
                  <span class="meta_name">
                    {{ order.giftName || '' }}
                  </span>
                </dd>
                <dt>{{ $t('views.member.orderdetail.6127') }}</dt>
                <dd>
                  <span class="meta_phone">{{ order.giftMobileNo || '' }}</span>
                </dd>
                <dt>{{ $t('views.member.orderdetail.7730') }}</dt>
                <dd>
                  <!-- <span class="meta_zipcode">{{
                    order.delivery ? order.delivery.zipCd : ''
                  }}</span
                  ><br /> -->
                  <span class="meta_address">{{ order.giftEmail || '' }}</span>
                </dd>
                <dt>선물사용 여부</dt>
                <dd>
                  <span class="meta_messagge">{{
                    `사용완료( ${order.giftConfirmDtime} )` || '미사용'
                  }}</span>
                </dd>
              </dl>
            </div>
          </div>

          <div class="box payment_info">
            <div class="top_title">
              <p>{{ $t('views.member.orderdetail.5913') }}</p>
            </div>
            <div class="receiver_wrap fl line_none">
              <dl>
                <dt>{{ $t('views.member.orderdetail.3988') }}</dt>
                <dd>
                  <!-- TODO: @Stan: not sure what this -->
                  <span class="meta_">{{ order.payment.payMethod }}</span>
                </dd>
              </dl>
              <div class="btn_wrap">
                <div class="cell">
                  <!-- TODO: @Stan should open new tab with receipt template sent from backend, generated from PG? -->
                  <a class="box_btn line" @click="showReceipt"
                    ><span class="an_t">{{
                      $t('views.member.orderdetail.9834')
                    }}</span></a
                  >
                </div>
              </div>
            </div>
            <div class="receiver_wrap fl">
              <dl>
                <dt>{{ $t('views.member.orderdetail.1152') }}</dt>
                <dd>
                  <span>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="meta-price"
                      format-style="currency"
                      :currency="order.orderGoodsList[0].currencyTp"
                      :number="order.payment.saleTotal"
                    />
                  </span>
                </dd>
                <dt>{{ $t('views.member.orderdetail.3539') }}</dt>
                <dd>
                  <span>
                    <vue-intl-numberformat
                      locale="ko-KR"
                      class="meta_price"
                      format-style="currency"
                      :currency="order.orderGoodsList[0].currencyTp"
                      :number="order.payment.paidTotal"
                    />
                  </span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="btn_wrap">
          <router-link :to="{ name: 'orders' }" class="box_btn">
            <span class="an_t">{{ $t('views.member.orderdetail.4485') }}</span>
          </router-link>
          &nbsp;
          <router-link :to="{ name: 'returns' }" class="box_btn">
            <span class="an_t">{{ $t('views.member.orderdetail.4486') }}</span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- ****************** -->
    <!-- CANCEL ORDER MODAL -->
    <!-- ****************** -->
    <transition name="modal-fade">
      <Modal v-if="showCancelOrderModal" @close="toggleCancelOrderModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleCancelOrderModal"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner cancel_model">
            <p class="tac">
              {{ $t('views.member.orderdetail.6625', { '1': order.orderCd }) }}
            </p>
            <p class="tac">{{ $t('views.member.orderdetail.82') }}</p>
            <div class="btn_wrap">
              <button
                class="ModalBtn box_btn dull"
                @click="toggleCancelOrderModal"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <button class="ModalBtn box_btn" @click="cancelOrder">
                <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>

    <!-- ****************** -->
    <!-- CANCEL RETURN ORDER MODAL -->
    <!-- ****************** -->
    <transition name="modal-fade">
      <Modal v-if="showCancelReturnModal" @close="toggleCancelReturnModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleCancelReturnModal"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner">
            <p class="tac">{{ $t('views.member.orderdetail.9997') }}</p>
            <!-- If order is  7 days+ old, show this -->
            <!-- No, just prevent the u -->
            <!-- <p class="tac">{{ $t('views.member.orderdetail.148') }}</p> -->

            <div class="btn_wrap">
              <button
                class="ModalBtn box_btn dull"
                @click="toggleCancelReturnModal"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <a class="ModalBtn box_btn" @click="cancelReturnOrder"
                ><span class="an_t">{{ $t('library.deletemodal.ok') }}</span></a
              >
            </div>
          </div>
        </div>
      </Modal>
    </transition>

    <!-- Message MODAL -->
    <transition v-on-clickaway="toggleMessageModal" name="modal-fade">
      <Modal v-if="showMessageModal" @close="toggleMessageModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleMessageModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ message }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleMessageModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import AccountHead from '@/components/member/AccountHead.vue'
import { ACCOUNT_ORDER_CANCEL } from '@/store/types'
import { mapGetters } from 'vuex'

export default {
  name: 'OrderDetail',

  components: {
    AccountHead
  },
  data() {
    return {
      showMessageModal: false,
      showSellerInfoModal: false,
      showCancelOrderModal: false,
      showCancelReturnModal: false,
      showErrorModal: false,
      order: null,
      message: '',
      currentTab: ''
    }
  },
  computed: {
    ...mapGetters(['getCurrency'])
  },
  mounted() {
    if (!this.$route.params.order) {
      this.$router.push({ name: 'orders' })
    } else {
      this.order = this.$route.params.order
    }

    if (this.$route.params.currentTab) {
      this.currentTab = this.$route.params.currentTab
    }
  },
  methods: {
    toggleMessageModal(message) {
      this.showMessageModal = !this.showMessageModal
      if (this.showMessageModal && message) {
        this.message = message
      }
    },
    toggleCancelOrderModal() {
      this.showCancelOrderModal = !this.showCancelOrderModal
    },
    toggleCancelReturnModal() {
      this.showCancelReturnModal = !this.showCancelReturnModal
    },
    async cancelOrder() {
      const id = this.order.orderCd
      try {
        await this.$store.dispatch(ACCOUNT_ORDER_CANCEL, id)
        this.toggleCancelOrderModal()
        this.$router.push({ name: 'returns' })
      } catch (err) {
        this.toggleCancelOrderModal()
        this.toggleMessageModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    },
    showReceipt() {
      window.open(this.order.payment.receiptUrl, '_blank')
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
// Fix Modal buttons
.ModalBtn {
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 20px 25px !important;
  .an_t {
    font-size: 16px !important;
    line-height: 1px !important;
  }
}
.none {
  pointer-events: none;
}
.delivery_info {
  .receiver_wrap.fl {
    dd {
      width: 100%;
    }
  }
}
.delivery_detail .box .fl {
  height: inherit;
}
.cancel_button {
  display: block;
  width: 50%;
  margin: auto;
}
.return_button {
  display: block;
  width: 50%;
  margin: auto;
}
.ly_inner.cancel_modal {
  padding-left: 45px;
  padding-right: 45px;
}
</style>
